export default __webpack_public_path__ + "static/media/11.ed0b0ab2.png";